import { FunctionalComponent, h } from "@stencil/core";

interface modalMultiIndicatorProps {
    current: number;
    total: number;
}

const baseClass = "ux-modal__multi";

export const ModalMultiIndicator: FunctionalComponent<modalMultiIndicatorProps> = ({ total, current }) => {
    if (total <= 1) {
        return null;
    }
    return (
        <div class={`${baseClass}`}>
            <ux-steps items={total} current={current} />
        </div>
    );
};
